import { getApiParams } from 'api/helpers';
import { selectPageModelCategoryId, selectPageModelRegionId } from 'store/pageModel';
import { all, call, put, select, takeLatest } from 'typed-redux-saga';
import {
	fetchConfiguratorsFailed,
	fetchConfiguratorsRequest,
	fetchConfiguratorsSuccess,
} from './slice';
import { fetchConfigurators, FetchConfiguratorsParams } from './api';

export function* getConfigurators() {
	try {
		const regionCode = yield* select(selectPageModelRegionId);
		const categoryId = yield* select(selectPageModelCategoryId);

		const { url, config } = yield* getApiParams(
			'/experience/servicesplatform/plasterlanding/v1/online-offers-by-category-id'
		);
		const params: FetchConfiguratorsParams = { regionCode, categoryId, types: 'project' };
		const { configurators } = yield* call(fetchConfigurators, url, params, config);
		yield* put(
			fetchConfiguratorsSuccess({
				configurators,
			})
		);
	} catch (error) {
		yield* put(
			fetchConfiguratorsFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* roughWorkSaga() {
	return yield* all([takeLatest(fetchConfiguratorsRequest, getConfigurators)]);
}
